module.exports = __webpack_public_path__ + "static/media/medals.cb1de8f1.png";